// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DatepickerTrigger — the collapsed pill + APPLY button (dark theme) */

.src-js-components-timeframeFilter-datepickerTrigger-module__triggerWrapper--GvlQk {
  position: relative;
  margin-bottom: 15px;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__triggerLabel--Qhbbu {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #A8B0B8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__helpIcon--MoA3f {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border: 1px solid currentColor;
  border-radius: 50%;
  font-size: 10px;
  line-height: 1;
  color: #A8B0B8;
  cursor: default;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__helpIconWrapper--BvbJN {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__tooltip--odBSI {
  position: absolute;
  top: 50%;
  left: calc(100% + 8px);
  transform: translateY(-50%);
  z-index: 1000;
  padding: 4px 8px;
  background-color: #FFFFFF;
  color: #000000;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  border: none;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.12s ease, visibility 0.12s ease;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__helpIconWrapper--BvbJN:hover .src-js-components-timeframeFilter-datepickerTrigger-module__tooltip--odBSI,
.src-js-components-timeframeFilter-datepickerTrigger-module__helpIconWrapper--BvbJN:focus-within .src-js-components-timeframeFilter-datepickerTrigger-module__tooltip--odBSI {
  opacity: 1;
  visibility: visible;
}

/* Row containing the pill + APPLY button */
.src-js-components-timeframeFilter-datepickerTrigger-module__triggerRow--sc6Gq {
  display: flex;
  align-items: center;
  gap: 12px;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__trigger--aOiRe {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 368px;
  height: 40px;
  padding: 6px 12px 6px 6px;
  border: 1px solid #FFFFFF;
  border-radius: 12px;
  background-color: #A8B0B8;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__trigger--aOiRe:hover {
  background-color: #6A7F99;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__triggerOpen--_mtTU {
  border-color: #FFFFFF;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__aggregateBadge--POvg6 {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 106px;
  height: 30px;
  padding: 5px 8px;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  background-color: #5D718C;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 8px;
  box-sizing: border-box;
  white-space: nowrap;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__calendarIcon--hGvDE {
  width: 22px;
  height: 22px;
  color: #FFFFFF;
  flex-shrink: 0;
  margin-right: -4px;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__dateText--ie0uD {
  width: 216px;
  height: 18px;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: normal;
  color: #FFFFFF;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__chevron--xyb_T {
  width: 16px;
  height: 9px;
  color: #FFFFFF;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__chevronOpen--uq8Jl {
  transform: rotate(180deg);
}

/* APPLY button — orange, outside the pill (Figma Image 2) */
.src-js-components-timeframeFilter-datepickerTrigger-module__applyButton--AnYIq {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #FF9600;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  white-space: nowrap;
}

.src-js-components-timeframeFilter-datepickerTrigger-module__applyButton--AnYIq:hover {
  background-color: #e6951a;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/timeframeFilter/datepickerTrigger.module.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qFAAqF;EACrF,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* DatepickerTrigger — the collapsed pill + APPLY button (dark theme) */\n\n.triggerWrapper {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n.triggerLabel {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #A8B0B8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 6px;\n}\n\n.helpIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border: 1px solid currentColor;\n  border-radius: 50%;\n  font-size: 10px;\n  line-height: 1;\n  color: #A8B0B8;\n  cursor: default;\n}\n\n.helpIconWrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.tooltip {\n  position: absolute;\n  top: 50%;\n  left: calc(100% + 8px);\n  transform: translateY(-50%);\n  z-index: 1000;\n  padding: 4px 8px;\n  background-color: #FFFFFF;\n  color: #000000;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Tahoma, Arial, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: normal;\n  text-transform: none;\n  white-space: nowrap;\n  border: none;\n  border-radius: 2px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.12s ease, visibility 0.12s ease;\n}\n\n.helpIconWrapper:hover .tooltip,\n.helpIconWrapper:focus-within .tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Row containing the pill + APPLY button */\n.triggerRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 368px;\n  height: 40px;\n  padding: 6px 12px 6px 6px;\n  border: 1px solid #FFFFFF;\n  border-radius: 12px;\n  background-color: #A8B0B8;\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.trigger:hover {\n  background-color: #6A7F99;\n}\n\n.triggerOpen {\n  border-color: #FFFFFF;\n}\n\n.aggregateBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  width: 106px;\n  height: 30px;\n  padding: 5px 8px;\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: -0.02em;\n  color: #FFFFFF;\n  background-color: #5D718C;\n  border: 1px solid rgba(255, 255, 255, 0.45);\n  border-radius: 8px;\n  box-sizing: border-box;\n  white-space: nowrap;\n}\n\n.calendarIcon {\n  width: 22px;\n  height: 22px;\n  color: #FFFFFF;\n  flex-shrink: 0;\n  margin-right: -4px;\n}\n\n.dateText {\n  width: 216px;\n  height: 18px;\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: normal;\n  color: #FFFFFF;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chevron {\n  width: 16px;\n  height: 9px;\n  color: #FFFFFF;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n/* APPLY button — orange, outside the pill (Figma Image 2) */\n.applyButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 24px;\n  background-color: #FF9600;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  white-space: nowrap;\n}\n\n.applyButton:hover {\n  background-color: #e6951a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triggerWrapper": `src-js-components-timeframeFilter-datepickerTrigger-module__triggerWrapper--GvlQk`,
	"triggerLabel": `src-js-components-timeframeFilter-datepickerTrigger-module__triggerLabel--Qhbbu`,
	"helpIcon": `src-js-components-timeframeFilter-datepickerTrigger-module__helpIcon--MoA3f`,
	"helpIconWrapper": `src-js-components-timeframeFilter-datepickerTrigger-module__helpIconWrapper--BvbJN`,
	"tooltip": `src-js-components-timeframeFilter-datepickerTrigger-module__tooltip--odBSI`,
	"triggerRow": `src-js-components-timeframeFilter-datepickerTrigger-module__triggerRow--sc6Gq`,
	"trigger": `src-js-components-timeframeFilter-datepickerTrigger-module__trigger--aOiRe`,
	"triggerOpen": `src-js-components-timeframeFilter-datepickerTrigger-module__triggerOpen--_mtTU`,
	"aggregateBadge": `src-js-components-timeframeFilter-datepickerTrigger-module__aggregateBadge--POvg6`,
	"calendarIcon": `src-js-components-timeframeFilter-datepickerTrigger-module__calendarIcon--hGvDE`,
	"dateText": `src-js-components-timeframeFilter-datepickerTrigger-module__dateText--ie0uD`,
	"chevron": `src-js-components-timeframeFilter-datepickerTrigger-module__chevron--xyb_T`,
	"chevronOpen": `src-js-components-timeframeFilter-datepickerTrigger-module__chevronOpen--uq8Jl`,
	"applyButton": `src-js-components-timeframeFilter-datepickerTrigger-module__applyButton--AnYIq`
};
export default ___CSS_LOADER_EXPORT___;
